<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <!-- <ul>
                 <li><a routerLink="/">Home</a></li>
                 <li>Contact</li>
             </ul>-->
            <h2>Grievance</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="breadcrumb-banner-area">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="breadcrumb-text">
                                <h1 class="text-center" style="color:green">CONTACT US</h1>
                                <p class="text-center" style="color:green"><a class="text-center" href="/"><u>Home</u></a>
                                </p>
                                <h3 class="text-center" > For Enquiry/Grievance:</h3>
                                <p class="text-center mb-10" >Contact: +91-7456901052 / 53</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-12">

            </div>
            <div class="col-lg-6 col-md-12 rounded p-5"
                 style="border: 1px solid black; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); background-color: #ede6e7;">
                <div class="contact-form">
                    <h2 style="text-align: center;">Grievance Form</h2>
                    <!--<p>Your email address will not be published. Required fields are marked *</p>-->
                    <!-- <form>
                         <div class="row">
                             <div class="col-lg-12 col-md-6">
                                 <div class="form-group">
                                     <input required minlength="3" maxlength="50" ngModel name="name" type="text"
                                            class="form-control" id="name" placeholder="Your name">
                                     <div class="alert alert-danger">
                                         <div>Name is required.</div>
                                         <div>Name is
                                             minimum character.
                                         </div>
                                         <div>Name is maximum 50 character.</div>
                                     </div>
                                 </div>
                             </div>
                             <div class="col-lg-12 col-md-6">
                                 <div class="form-group">
                                     <input required ngModel name="email" type="text" #email="ngModel"
                                            class="form-control" id="email" placeholder="Your email address">
                                     <div class="alert alert-danger" *ngIf="email.touched && !email.valid">Email Address
                                         is required.
                                     </div>
                                 </div>
                             </div>
                             <div class="col-lg-12 col-md-12">
                                 <div class="form-group">
                                     <input required ngModel name="number" type="text" #number="ngModel"
                                            class="form-control" id="number" placeholder="Your phone number">
                                     <div class="alert alert-danger" *ngIf="number.touched && !number.valid">Phone number
                                         is required.
                                     </div>
                                 </div>
                             </div>
                             <div class="col-lg-12 col-md-12">
                                 <div class="form-group">
                                     <textarea required ngModel #message="ngModel" name="message" id="message" cols="30"
                                               rows="5" class="form-control"
                                               placeholder="Write your message..."></textarea>
                                     <div class="alert alert-danger">Message is
                                         required.
                                     </div>
                                 </div>
                             </div>
                             <div class="col-lg-12 col-md-12">
                                 <button type="submit" class="default-btn">Send
                                     Message<span></span></button>
                             </div>
                         </div>
                     </form>-->
                    <div class="container mt-3">
                        <!--<h2>Stacked form</h2>-->
                        <form #userPost="ngForm" (ngSubmit)="onSubmit(userPost.value)">
                            <div class="mb-3 mt-3">
                                <label>Name:</label>
                                <input ngModel type="text" class="form-control" id="name" placeholder="Enter Name"
                                       name="name">
                            </div>
                            <div class="mb-3 mt-3">
                                <label>Father/Husband's Name:</label>
                                <input ngModel type="text" class="form-control" id="fatheName" placeholder="Father/Husband's Name"
                                       name="fatheName">
                            </div>
                            <div class="mb-3 mt-3">
                                <label>Date of Birth:</label>
                                <input ngModel type="text" class="form-control" id="DOB" placeholder="Date of birth"
                                       name="DOB">
                            </div>
                            
                            <div class="mb-3 mt-3">
                                <label>Enrollment No.:</label>
                                <input ngModel type="text" class="form-control" id="EnrollmentNo" placeholder="Enrollment No."
                                       name="EnrollmentNo">
                            </div>
                            <div class="mb-3 mt-3">
                                <label for="email">Email:</label>
                                <input ngModel type="email" class="form-control" id="email" placeholder="Enter email"
                                       name="email">
                            </div>
                            <div class="mb-3">
                                <label for="Number">Number:</label>
                                <input ngModel type="number" class="form-control" id="Number" placeholder="Number"
                                       name="Number">
                            </div>
                            <div class="mb-3">
                                <label for="comment">Comments:</label>
                                <textarea ngModel class="form-control" rows="5" id="comment" name="comment"></textarea>
                            </div>
                            <button type="submit" class="btn  text-center float-end"
                                    style="background-color: #29166b; color: white;">Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-12">
            </div>
        </div>
    </div>
</div>

